import React, { useEffect, useState } from "react";
import { Box, TextField, Typography, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  getAuth,
  signInWithPhoneNumber,
  RecaptchaVerifier,
} from "firebase/auth";
import Toast from "react-hot-toast";
import TextBox from "../../../components/TextField";
import Button from "../../../components/Button";
import Logo from "../../../assets/images/Logo.png";
import Routes from "../../../utils/Routes";
import Alert from "../../../components/Alert";

function ProfileSendOTP({ className }) {
  const navigate = useNavigate();
  const auth = getAuth();
  const [phone, setPhone] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  // useEffect(() => {
  //   if (!window.recaptchaVerifier) {
  //     window.recaptchaVerifier = new RecaptchaVerifier(
  //       "recaptcha-container",
  //       {
  //         size: "invisible",
  //       },
  //       auth
  //     );
  //   }
  // }, []);

  // const setupRecaptcha = () => {
  //   if (!window.recaptchaVerifier) {
  //     window.recaptchaVerifier = new RecaptchaVerifier(
  //       "recaptcha-container",
  //       {
  //         size: "invisible",
  //       },
  //       auth
  //     );
  //   }
  // };

  const isValidPhoneNumber = (phone) => {
    const sanitizedPhone = phone.replace(/[^0-9]/g, "");
    if (sanitizedPhone.length !== 10) return false;
    const repeatingDigitsPattern = /^(\d)\1{10}$/;
    return !repeatingDigitsPattern.test(sanitizedPhone);
  };

  const sendOTPHandler = async () => {
    if (phone.length < 10 || !isValidPhoneNumber(phone)) {
      setAlert({
        open: true,
        message: "Please enter a valid phone number.",
        severity: "warning",
      });
      return;
    }

    try {
      setIsLoading(true);

      // setupRecaptcha();
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
        }
      );

      const confirmationRes = await signInWithPhoneNumber(
        auth,
        `+1${phone}`,
        window.recaptchaVerifier
      );
      setIsLoading(false);

      navigate("/" + Routes.ProfileOTPSubmit, {
        state: {
          verificationId: confirmationRes.verificationId,
          phone: phone,
        },
      });

      Toast.success("One Time Password sent successfully!");
    } catch (error) {
      setIsLoading(false);
      setAlert({
        open: true,
        message: "Failed to send One Time Password. Please try again!",
        severity: "error",
      });
    }
  };

  return (
    <div className={className}>
      <Box className="container">
        <Box className="headingContainer">
          <img src={Logo} alt="Logo" className="logo" />
          <Typography variant="h4" className="heading">
            Forgot Password
          </Typography>
        </Box>

        <Box className="form">
          <TextBox
            placeholder="Enter Phone Number"
            value={phone}
            type="tel"
            onChange={(e) => {
              const sanitizedText = e.target.value
                .replace(/[^0-9]/g, "")
                .slice(0, 10);
              setPhone(sanitizedText);
            }}
          />

          <Box className="buttonContainer">
            <Button
              label="Send One Time Password"
              variant="contained"
              color="primary"
              onClick={sendOTPHandler}
            />

            <Button
              label="Cancel"
              variant="outlined"
              color="primary"
              onClick={() => navigate(-1)}
            />
          </Box>
        </Box>

        {/* Invisible reCAPTCHA */}
        <button id="recaptcha-container" style={{ display: "none" }}></button>
      </Box>
      <Alert
        open={alert.open}
        message={alert.message}
        severity={alert.severity}
        onClose={() => setAlert({ ...alert, open: false })}
      />
    </div>
  );
}

export default styled(ProfileSendOTP)(() => ({
  ".container": {
    maxWidth: "400px",
    margin: "auto",
    padding: "20px",
    textAlign: "center",
  },
  ".heading": {
    fontFamily: "League Spartan",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "#234000",
    marginTop: "3%",
  },
  ".form": {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  ".buttonContainer": {
    display: "flex",
    flexDirection: "column",
  },
  ".logo": {
    width: 94,
    height: 94,
  },
  ".headingContainer": {
    marginTop: "17%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
}));
